import React from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { IntroReveal } from "../components/IntroReveal";
import { Marquee } from "../components/Marquee";
import { ComicsSection } from "../components/ComicsSection";
import { CharactersSection } from "../components/CharactersSection";
import { LoreSection } from "../components/LoreSection";
import { JoinSection } from "../components/JoinSection";
import { Footer } from "../components/Footer";
import { useAuth } from "../context/AuthContext";

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleGate = (mode) => {
    if (mode === "subscribe" || (mode === "read" && user === false)) {
      navigate("/register");
    } else {
      scrollTo("#join");
    }
  };

  return (
    <div className="App" data-testid="home-page">
      <IntroReveal />
      <Navbar logoImage />
      <Hero
        onJoin={() => scrollTo("#join")}
        onSubscribe={() => (user === false ? navigate("/register") : scrollTo("#comics"))}
        onEarlyAccess={() => scrollTo("#join")}
      />
      <Marquee />
      <ComicsSection onGate={handleGate} />
      <CharactersSection onJoin={() => scrollTo("#join")} />
      <LoreSection />
      <JoinSection />
      <Footer />
    </div>
  );
}
